var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var width = "60.7%";
var height = "6.4%";
var left = "18.7%";
var isExternal = true;
var iniTop = 12.4;
var padding = 19.8 - iniTop;
var links = [
    ["ICS Insights series", "https://www.isflive.org/s/topic/0TO0J0000009AOWWA2/ics-security-support-community"],
    ["Embedding Security into Agile Development", "https://www.isflive.org/s/article/Embedding-Security-into-Agile-Development-Ten-principles-for-rapid-improvement-Report"],
    ["Threat Horizon 2024: The disintegration of trust", "https://www.isflive.org/s/article/Threat-Horizon-2024-the-disintegration-of-trust-report?topicId=0TO0J0000009AODWA2"],
    ["QIRA Assistant", "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology-Assistant"],
    ["Demystifying Zero Trust - Briefing Paper", "https://www.isflive.org/s/article/Demystifying-Zero-Trust-Briefing-Paper"],
    ["Quantitative Information Risk Assessment (QIRA) - Methodology", "https://www.isflive.org/s/article/Quantitative-Information-Risk-Assessment-QIRA-Methodology"],
    ["Securing Containers: Keeping pace with change - Briefing Paper", "https://www.isflive.org/s/article/Securing-Containers-Keeping-pace-with-change-Briefing-paper"],
    ["Security Architecture: Navigating complexity - Report", "https://www.isflive.org/s/article/Security-Architecture-Navigating-complexity-Report"],
    ["Securing the Supply Chain - Preventing your suppliers vulnerabilities from becoming your own - Report", "https://www.isflive.org/s/article/Securing-the-Supply-Chain-Preventing-your-suppliers-vulnerabilities-from-becoming-your-own-Report?topicId=0TO0J0000009AOCWA2"],
    ["Deploying Open Source Software: Challenges and rewards - Briefing Paper", "https://www.isflive.org/s/article/Deploying-Open-Source-Software-Challenges-and-Rewards-Briefing-Paper"]
].map(function (line, idx) { return ({
    label: line[0],
    href: line[1],
    width: width,
    height: height,
    left: left,
    isExternal: isExternal,
    top: "".concat(iniTop + (padding * idx), "%"),
    target: "_blank"
}); });
export default __spreadArray(__spreadArray([], links, true), [{
        width: "28.7%",
        height: "5.4%",
        left: "34.7%",
        isExternal: isExternal,
        top: "88%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }], false);
